import type { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/salary-grades';

export const getSalaryScalesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/salary-scales/dropdown`);
};
